export enum ChatStatus {
  All = 0,
  UnreadOnly = 1,
}
